package devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentTool

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.WebDesignBoxes
import devxertech.com.pages.commons.toolUseHeading
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun AiDevelopmentTool(breakpoint: Breakpoint, sitePalette: SitePalette, text: String){
    Column(modifier = Modifier.fillMaxWidth().padding(top = if (breakpoint < Breakpoint.MD) 10.px else 60.px,
        bottom = if (breakpoint < Breakpoint.MD) 0.px else 60.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        toolUseHeading(breakpoint)
        Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            FieldTitleTextNormalSimple(
                "OUR FAVOURITES IN ",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                fontWeight = 600,
                marginBottom = if (breakpoint < Breakpoint.MD) 5.px else 20.px
            )
            FieldTitleTextNormalSimple(
                text = text,
                color = sitePalette.primary.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                fontWeight = 600,
                marginBottom = if (breakpoint < Breakpoint.MD) 5.px else 20.px
            )
        }
        Column(modifier = Modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(modifier = Modifier.fillMaxWidth
                (when {breakpoint > Breakpoint.LG -> 1200.px
                breakpoint == Breakpoint.LG -> 100.percent
                breakpoint >= Breakpoint.MD -> 85.percent
                else -> 100.percent })
                .padding(top = 30.px, bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px)
                .gap(when {breakpoint < Breakpoint.MD -> 5.px
                    breakpoint == Breakpoint.MD -> 25.px
                    breakpoint == Breakpoint.LG -> 10.px
                    else -> 33.px })
                .flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.SpaceAround,
                verticalAlignment = Alignment.CenterVertically
            ) {
                WebDesignBoxes(Res.Image.mob_react, "React", 62.px, 62.px, 0.px,0.px)
                WebDesignBoxes(Res.Image.angular, "Angular", 56.px, 58.px,0.px,0.px)
                WebDesignBoxes(Res.Image.laravelIcon, "Laravel", 57.px, 55.px,0.px,0.px)
                WebDesignBoxes(Res.Image.netLogo, ".Net", 75.px, 45.px)
                WebDesignBoxes(Res.Image.django_logo, "Django", 96.px, 42.px)
            }
        }
    }
}